import { makeStyles } from '@material-ui/styles';
import { Theme, Text } from '@bizzabo/design-system';

const ChatMessageDialogDescription = ({ children }) => {
    const classes = useStyles();
    return (
        <Text variant="t81" className={classes.content}>
            {children}
        </Text>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        content: {
            'text-align': 'center',
            color: theme.palette.greys['600'],
            paddingBottom: 24,
        },
    }),
    {
        classNamePrefix: 'ChatMessageDialogDescription',
    }
);
export default ChatMessageDialogDescription;
